import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/lib/AuthContext";
import Home, { PaketList, PaketDetail } from "@/pages/PublicPages";
import { Toko, TokoDetail, Artikel, ArtikelDetail, TentangKami, CekBooking, Kontak } from "@/pages/MorePages";
import { Login, Register, AuthCallback, ForgotPassword, ResetPassword } from "@/pages/AuthPages";
import PortalPicker from "@/pages/PortalPicker";
import BookingWizard, { ShopCheckout } from "@/pages/BookingFlow";
import PaketUmrah from "@/pages/PaketUmrah";
import { ECourseList, ECourseDetail } from "@/pages/ECourse";
import {
  PortalDashboard, PortalBookings, PortalPilgrims, PortalInvoices, PortalDocuments,
  PortalSchedule, PortalOrders, PortalNotifications, PortalProfile,
} from "@/pages/JamaahPortal";
import { RequireAuth, ComingSoon } from "@/erp/shell";
import Dashboard from "@/erp/Dashboard";
import ProductsAdmin from "@/erp/ProductsAdmin";
import { PartnersAdmin, UsersAdmin, DocumentsAdmin } from "@/erp/AdminPages";
import { CmsAdmin, SettingsAdmin } from "@/erp/CmsSettings";
import { BookingAdmin, PaymentsAdmin, PayoutAdmin, CancellationsAdmin } from "@/erp/Transactions";
import TokoAdmin from "@/erp/TokoAdmin";
import FinanceAdmin, { PartnerPortal } from "@/erp/FinancePortal";
import ECourseAdmin from "@/erp/ECourseAdmin";
import { LaporanOperasional } from "@/erp/LaporanOperasional";

function AppRouter() {
  const location = useLocation();

  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) localStorage.setItem("rsh_ref", ref);
  }, [location]);

  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/paket-umrah" element={<PaketUmrah />} />
      <Route path="/paket/umrah-private" element={<Navigate to="/paket-umrah" replace />} />
      <Route path="/paket/umrah-reguler" element={<Navigate to="/paket-umrah" replace />} />
      <Route path="/paket/umrah-mandiri" element={<Navigate to="/paket-umrah" replace />} />
      <Route path="/umrah-mandiri" element={<Navigate to="/paket-umrah" replace />} />
      <Route path="/e-course" element={<ECourseList />} />
      <Route path="/e-course/:slug" element={<ECourseDetail />} />
      <Route path="/paket/:category" element={<PaketList />} />
      <Route path="/paket-detail/:slug" element={<PaketDetail />} />
      <Route path="/booking/:slug" element={<BookingWizard />} />
      <Route path="/haji-khusus" element={<PaketList fixedCategory="haji-khusus" title="Haji Khusus" />} />
      <Route path="/toko" element={<Toko />} />
      <Route path="/toko/:slug" element={<TokoDetail />} />
      <Route path="/checkout" element={<ShopCheckout />} />
      <Route path="/artikel" element={<Artikel />} />
      <Route path="/artikel/:slug" element={<ArtikelDetail />} />
      <Route path="/tentang-kami" element={<TentangKami />} />
      <Route path="/cek-booking" element={<CekBooking />} />
      <Route path="/kontak" element={<Kontak />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/lupa-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/pilih-portal" element={<PortalPicker />} />

      <Route path="/portal" element={<RequireAuth><PortalDashboard /></RequireAuth>} />
      <Route path="/portal/booking" element={<RequireAuth><PortalBookings /></RequireAuth>} />
      <Route path="/portal/rombongan" element={<RequireAuth><PortalPilgrims /></RequireAuth>} />
      <Route path="/portal/tagihan" element={<RequireAuth><PortalInvoices /></RequireAuth>} />
      <Route path="/portal/dokumen" element={<RequireAuth><PortalDocuments /></RequireAuth>} />
      <Route path="/portal/jadwal" element={<RequireAuth><PortalSchedule /></RequireAuth>} />
      <Route path="/portal/order" element={<RequireAuth><PortalOrders /></RequireAuth>} />
      <Route path="/portal/notifikasi" element={<RequireAuth><PortalNotifications /></RequireAuth>} />
      <Route path="/portal/profil" element={<RequireAuth><PortalProfile /></RequireAuth>} />

      <Route path="/erp" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/erp/produk" element={<RequireAuth perm="product.read"><ProductsAdmin /></RequireAuth>} />
      <Route path="/erp/cms" element={<RequireAuth perm="cms.read"><CmsAdmin /></RequireAuth>} />
      <Route path="/erp/mitra" element={<RequireAuth perm="partner.read"><PartnersAdmin /></RequireAuth>} />
      <Route path="/erp/portal-mitra" element={<RequireAuth perm="partner.portal"><PartnerPortal /></RequireAuth>} />
      <Route path="/erp/pengguna" element={<RequireAuth perm="user.read"><UsersAdmin /></RequireAuth>} />
      <Route path="/erp/dokumen" element={<RequireAuth perm="document.read"><DocumentsAdmin /></RequireAuth>} />
      <Route path="/erp/e-course" element={<RequireAuth perm="course.write"><ECourseAdmin /></RequireAuth>} />
      <Route path="/erp/pengaturan" element={<RequireAuth perm="settings.read"><SettingsAdmin /></RequireAuth>} />
      <Route path="/erp/booking" element={<RequireAuth perm="booking.read"><BookingAdmin /></RequireAuth>} />
      <Route path="/erp/pembayaran" element={<RequireAuth perm="payment.read"><PaymentsAdmin /></RequireAuth>} />
      <Route path="/erp/toko" element={<RequireAuth perm="booking.read"><TokoAdmin /></RequireAuth>} />
      <Route path="/erp/payout" element={<RequireAuth perm="commission.read"><PayoutAdmin /></RequireAuth>} />
      <Route path="/erp/pembatalan" element={<RequireAuth perm="booking.read"><CancellationsAdmin /></RequireAuth>} />
      <Route path="/erp/keuangan" element={<RequireAuth perm="finance.read"><FinanceAdmin /></RequireAuth>} />
      <Route path="/erp/laporan" element={<RequireAuth perm="report.read"><LaporanOperasional /></RequireAuth>} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
